import BaseMessageRecord from "../BaseMessageRecord";
import { httpMessageRecordDefaultAttributes, getInvalidHttpFields } from "../HTTPMessageRecord";

class ShopifyMessageRecord extends BaseMessageRecord({
  ...httpMessageRecordDefaultAttributes,
  displayType: "shopify"
}) {}

ShopifyMessageRecord.getInvalidFields = getInvalidHttpFields;

export default ShopifyMessageRecord;
